export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [7,[2]],
		"/(app)/admin": [8,[2,3]],
		"/(app)/admin/announcements": [9,[2,3]],
		"/(app)/admin/chat_history": [10,[2,3]],
		"/(app)/admin/evaluations": [11,[2,3]],
		"/(app)/admin/functions": [12,[2,3]],
		"/(app)/admin/functions/create": [13,[2,3]],
		"/(app)/admin/functions/edit": [14,[2,3]],
		"/(app)/admin/settings": [15,[2,3]],
		"/(app)/admin/users": [16,[2,3]],
		"/auth": [38],
		"/(app)/channels/[id]": [18,[2]],
		"/(app)/c/[id]": [17,[2]],
		"/error": [39],
		"/(app)/home": [19,[2,4]],
		"/(app)/playground": [20,[2,5]],
		"/(app)/playground/completions": [21,[2,5]],
		"/(app)/playground/notes": [22,[2,5]],
		"/s/[id]": [40],
		"/watch": [41],
		"/(app)/workspace": [23,[2,6]],
		"/(app)/workspace/functions/create": [24,[2,6]],
		"/(app)/workspace/knowledge": [25,[2,6]],
		"/(app)/workspace/knowledge/create": [27,[2,6]],
		"/(app)/workspace/knowledge/[id]": [26,[2,6]],
		"/(app)/workspace/models": [28,[2,6]],
		"/(app)/workspace/models/create": [29,[2,6]],
		"/(app)/workspace/models/edit": [30,[2,6]],
		"/(app)/workspace/prompts": [31,[2,6]],
		"/(app)/workspace/prompts/create": [32,[2,6]],
		"/(app)/workspace/prompts/edit": [33,[2,6]],
		"/(app)/workspace/reviews": [34,[2,6]],
		"/(app)/workspace/tools": [35,[2,6]],
		"/(app)/workspace/tools/create": [36,[2,6]],
		"/(app)/workspace/tools/edit": [37,[2,6]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.svelte';